const IPV4_LITERAL_REGEX = /^\d{1,3}(?:\.\d{1,3}){3}$/;
const IPV6_LITERAL_REGEX = /^\[?[\da-f:.]*:[\da-f:.]*\]?$/i;
const LOCAL_NAME_REGEX = /^(?:localhost|(?:[a-z\d-]+\.)+local)$/i;

/**
 * Whether the host a dev client loaded its bundle from (Expo's `hostUri`) is a dev server on this
 * machine or its network, served over plain HTTP on its own port, rather than a TLS-terminated
 * tunnel domain such as `metro.haniverse.dev`.
 *
 * Any IP literal counts, not only RFC 1918 ranges: a phone on Wi-Fi can be handed a 100.64.0.0/10
 * address, and the Mac's address on an iPhone's USB hotspot is in 172.20.10.0/28.
 */
export function isLocalDevServerHostname(hostname: string): boolean {
  return (
    IPV4_LITERAL_REGEX.test(hostname) ||
    IPV6_LITERAL_REGEX.test(hostname) ||
    LOCAL_NAME_REGEX.test(hostname)
  );
}
